import { Component, HostListener, OnInit } from '@angular/core';
import { UserListService } from "app/user/user-list/user-list.service";
import { Router } from "@angular/router";
import { UserListResource } from "app/resources/user/user-list-resource";
import { isNull } from "util";
import { Timestamp } from 'app/models/Timestamp';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { FilterCriteriaListEdt } from 'app/models/FilterCriteriaListEdt';
import { FilterCriteriaEDT } from '../../models/FilterCriteriaEDT';
import { UserResource } from '../../models/UserResource';
import { forkJoin } from 'rxjs';
import { UtilsService } from 'app/services/utils.service';
import { UserFilter } from 'app/models/UserFilter';
import { RoleListResource } from 'app/resources/role/role-list-resource';
import { AddUserService } from 'app/user/add-user/add-user.service';
@Component({
	selector: 'vbn-appointments-officers-list',
	templateUrl: './appointments-officers-list.component.html',
	styleUrls: ['./appointments-officers-list.component.scss']
})
export class AppointmentsOfficersListComponent implements OnInit {
	userListResource: UserListResource;
	errorMessage: string;
	pageNumber: number;
	configPagination: any;
	numberOfEventsPerPage: number;
	isEmail: boolean = false;
	isAscCompanyName: boolean = false;
	isAscRole: boolean = false;
	isAscCreatedDate: boolean = false;
	isAscFirstName: boolean = false;
	isAscBpo: boolean = false;
	column: string = '';
	status: any;
	event: {
		email: string;
		companyName: string;
		role: {
			name: string;
		}
		createdDate: Timestamp;
		bpo: boolean;
	};
	userEmail: string;
	selectedClient: string;
	roleId: number;
	bpoTlNotAllow = false;
	bpoOfficerNotAllow = false;
	roleListResource: RoleListResource;
	isOnResponsive: boolean = false;


	constructor(private userListService: UserListService, private router: Router, private _notificationService: NotificationsService,
		private translate: TranslateService, private service: UtilsService,
		private addUserService: AddUserService) {
		this.userListResource = new UserListResource();
		this.userListResource.users = [];
		this.numberOfEventsPerPage = 15;
		this.pageNumber = 1;
		this.event = {
			email: null,
			companyName: null,
			role: {
				name: "0"
			},
			createdDate: null,
			bpo: undefined
		};
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		const innerWidth = window.innerWidth;
		if (innerWidth <= 1300) {
			this.isOnResponsive = true;
		}
		else {
			this.isOnResponsive = false;
		}
	}

	ngOnInit() {
		this.roleId = parseInt(localStorage.getItem("_roleId"));
		if (this.roleId === 4) {
			this.bpoOfficerNotAllow = true;
		} else {
			if (this.roleId === 3) {
				this.bpoTlNotAllow = true;
			}
		}
		this.userEmail = this.service.currentUserEmail;
		this.selectedClient = (localStorage.getItem("_sc") === null) ? null : atob(localStorage.getItem("_sc")); // if we have a selected client in dashboard
		this.getUserList(null);
		this.getRolesList();

		if (innerWidth <= 1300) {
			this.isOnResponsive = true;
		}
		else {
			this.isOnResponsive = false;
		}
	}

	delete(elem) {
		elem.showDelete = true;
	}

	getRolesList() {
		this.addUserService.getUserRoles('/admin/role/getAll')
			.subscribe(
				response => {
					this.roleListResource = response;
				},
				error => this.errorMessage = <any>error);
	}
	getUserList(property) {

		let userFilter = new UserFilter();
		userFilter.pageNumber = this.pageNumber;
		userFilter.itemPerPage = this.numberOfEventsPerPage;
		userFilter.email = this.event.email;
		userFilter.companyName = this.event.companyName;
		userFilter.roleKey = (this.event.role.name === "0") ? null : this.event.role.name;
		if (this.event.createdDate !== null) {
			const year = new Date(this.event.createdDate + "").getFullYear();
			const month = (new Date(this.event.createdDate + "").getMonth() < 9) ? "0" + (new Date(this.event.createdDate + "").getMonth() + 1) : new Date(this.event.createdDate + "").getMonth() + 1;
			const day = (new Date(this.event.createdDate + "").getDate() < 10) ? "0" + (new Date(this.event.createdDate + "").getDate()) : new Date(this.event.createdDate + "").getDate();
			userFilter.dateCreated = year + "-" + month + "-" + day;
		} else {
			userFilter.dateCreated = null;
		}
		userFilter.bpo = this.event.bpo;
		userFilter.clientUser = this.selectedClient;

		this.userListService.post('/admin/user/getAllWithoutLoggedUser', userFilter)
			.subscribe(
				response => {
					this.userListResource = response;
					if (this.userListResource.errorCode == 1002) {
						forkJoin(
							this.translate.get('Error'),
							this.translate.get('0 items found after the search!')
						).subscribe((res) => {
							this._notificationService.create(res[0], res[1], 'error')
						});
						this.userListResource = new UserListResource();
						this.userListResource.users = [];
					}
					this.configPagination = {
						cap: response.numberOfPages,
						start: this.pageNumber
					}
				},
				error => this.errorMessage = <any>error);
	}

	handlePageChange(event) {
		this.pageNumber = event
		this.getUserList(null)
	}

	goToEdit(email: string) {
		this.router.navigate(['/add-edit-appointments-officers/' + btoa('{ "userEmail" : "' + email + '"}')]);
	}

	deleteUser(email: string) {
		this.userListService.get('/admin/user/deleteUserByOwner?email=' + email)
			.subscribe(
				response => {
					this.getUserList(null);
				},
				error => this.errorMessage = <any>error);
	}
	resetFilter() {
		this.event = {
			email: null,
			companyName: null,
			role: {
				name: "0"
			},
			createdDate: null,
			bpo: undefined
		};
		this.getUserList(null);
	}

	showResponsiveDetails(email) {
		const width = window.innerWidth;
		if (width <= 1300) {
			for (let i = 0; i < this.userListResource.users.length; i++) {
				if (this.userListResource.users[i].email === email) {
					this.userListResource.users[i].showDetailsOnResponsive = !this.userListResource.users[i].showDetailsOnResponsive;
				}
				else {
					this.userListResource.users[i].showDetailsOnResponsive = false;
				}
			}
		}
		else {
			return;
		}

	}
}